var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg123(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83334 10H3.83334V7H2.83334V6H4.83334V10ZM9.16668 9H7.16668V8.33333H8.50001C8.86668 8.33333 9.16668 8.03333 9.16668 7.66667V6.66667C9.16668 6.3 8.86668 6 8.50001 6H6.16668V7H8.16668V7.66667H6.83334C6.46668 7.66667 6.16668 7.96667 6.16668 8.33333V10H9.16668V9ZM13.1667 9.33333V6.66667C13.1667 6.3 12.8667 6 12.5 6H10.1667V7H12.1667V7.66667H10.8333V8.33333H12.1667V9H10.1667V10H12.5C12.8667 10 13.1667 9.7 13.1667 9.33333Z",
    fill: "#39657E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg123);
export default __webpack_public_path__ + "static/media/123.138b7cc0a1535d10450bd797aeaad485.svg";
export { ForwardRef as ReactComponent };